<template>
  <div class="container mt-4">
    <div class="row">
      <div class="col">
        <button v-if="freshGroup === -1" class="btn btn-primary float-end" @click="addGroup()">Lisa uus</button>
        <h2>Grupid</h2>
        <table class="table">
          <!-- Table heading -->
          <thead>
          <tr>
            <th>Grupi nimi</th>
            <th>Lühend</th>
            <th>Värv</th>
            <th></th>
          </tr>
          </thead>
          <!-- Table contents -->
          <tbody>
          <tr v-for="group in groups" :key="group.id">
            <td>
              <input type="text" class="form-control" :disabled="editing !== group.id" v-model="group.name" placeholder="Grupi nimetus">
            </td>
            <td>
              <input type="text" maxlength="20" class="form-control" :disabled="editing !== group.id" v-model="group.short" placeholder="Lühend">
            </td>
            <td>
              <input type="color" :disabled="editing !== group.id" v-model="group.color">
            </td>
            <td>
              <!-- Show when adding new group -->
              <div v-if="group.id === undefined">
                <button class="btn btn-outline-secondary btn-lg" type="button" @click="cancelAdd()">Tühista</button>
                <button class="btn btn-primary btn-lg ms-2" :disabled="group.name === undefined || group.name === ''" type="button" @click="createGroup()">Salvesta grupp</button>
              </div>
              <!-- Show when editing existing alarm -->
              <div v-if="editing === group.id && editing !== undefined" class="float-end">
                <button class="btn btn-outline-danger btn-sm me-2" type="button" @click="removeGroup(group.id)">Kustuta</button>
                <button class="btn btn-outline-secondary btn-lg me-2" type="button" @click="editing = null">Tühista</button>
                <button class="btn btn-primary btn-lg" type="button" @click="saveGroup(group.id)">Salvesta</button>
              </div>

              <div class="d-grid" v-if="editing === null">
                <button class="btn btn-secondary" @click="editing = group.id">Muuda</button>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios'

export default {
  data () {
    return {
      groups: [],
      editing: null
    }
  },
  watch: {
    '$store.state.groups': function () {
      this.groups = this.$store.state.groups
    }
  },
  mounted () {
    this.groups = this.$store.state.groups
  },
  methods: {
    addGroup () {
      this.groups.unshift({})
      this.editing = undefined
    },
    // Save updated group in DB
    saveGroup (id) {
      const _this = this
      const token = localStorage.getItem('localToken')
      console.log(this.groups.find(obj => obj.id === id))
      axios.post(this.$store.state.api + '/updateGroup', this.groups.find(obj => obj.id === id), { headers: { Authorization: `${token}`, 'Project-Name': this.$store.state.project.code } })
        .then(function (response) {
          console.log(response.data)
          _this.$swal({ icon: 'success', title: 'Salvestatud', showConfirmButton: false, timer: 1500 })
        })
        .catch(function (error) {
          console.log(error)
          _this.$swal({ icon: 'error', title: 'Tekkis viga', showConfirmButton: false, timer: 1500 })
          _this.$store.dispatch('getGroups')
        })
      this.editing = null
    },
    // Delete group from DB
    removeGroup (id) {
      const group = this.groups.find(obj => obj.id === id)
      this.$swal({
        title: 'Oled kindel?',
        text: 'Eemalda grupp "' + group.name + '"?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Jah, eemalda!',
        cancelButtonText: 'Katkesta'
      }).then((result) => {
        if (result.isConfirmed) {
          const _this = this
          const token = localStorage.getItem('localToken')
          axios.post(this.$store.state.api + '/deleteGroup', { id: id }, { headers: { Authorization: `${token}`, 'Project-Name': this.$store.state.project.code } })
            .then(function (response) {
              _this.$store.dispatch('getGroups')
              _this.groups = _this.groups.filter(obj => obj.id !== id)
              _this.$swal('Valmis!', 'Grupp "' + group.name + '" eemaldati', 'success')
            })
            .catch(function (error) {
              console.log(error)
              _this.$store.dispatch('getGroups')
            })
        }
      })
    },
    // Create new group in DB
    createGroup () {
      const _this = this
      const token = localStorage.getItem('localToken')
      axios.post(this.$store.state.api + '/insertGroup', this.groups.find(obj => obj.id === undefined), { headers: { Authorization: `${token}`, 'Project-Name': this.$store.state.project.code } })
        .then(function (response) {
          console.log(response.data)
          _this.groups = _this.groups.filter(obj => obj.id !== undefined)
          _this.$swal({ icon: 'success', title: 'Uus grupp lisatud', showConfirmButton: false, timer: 1500 })
          _this.$store.dispatch('getGroups')
        })
        .catch(function (error) {
          console.log(error)
          _this.$swal({ icon: 'error', title: 'Tekkis viga', showConfirmButton: false, timer: 1500 })
          _this.$store.dispatch('getGroups')
        })
      this.editing = null
    },
    // Cancel adding new group
    cancelAdd () {
      this.groups = this.groups.filter(obj => obj.id !== undefined)
      this.editing = null
    }
  },
  computed: {
    // Find array index for fresh user that has not been saved
    freshGroup: function () {
      return this.groups.findIndex(obj => obj.id === undefined)
    }
  }
}
</script>
